import { render, staticRenderFns } from "./BossWx.vue?vue&type=template&id=2ca4ebbf&scoped=true&"
import script from "./BossWx.vue?vue&type=script&lang=js&"
export * from "./BossWx.vue?vue&type=script&lang=js&"
import style0 from "./BossWx.vue?vue&type=style&index=0&id=2ca4ebbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca4ebbf",
  null
  
)

export default component.exports